<template>
  <div class="cover-center media-large">
    <div class="layer media-container">
      <slot name="media"></slot>
    </div>

    <div class="layer content-container">
      <div class="content-box">
        <slot name="header"></slot>
        <slot name="jobCounter"></slot>
        <slot name="ctaButton"></slot>
        <slot name="search"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoverCenter",
};
</script>

<style lang="scss" scoped>
@import "../scss/shared";
@import "../scss/media-large";

.content-container {
  justify-content: center;
  align-items: center;
}

.content-box {
  text-align: center;
}
</style>
